import type { CancelablePopupContent } from './type';

const presets = {
  removeWidget: {
    title: 'Remove app?',
    text: 'This app will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Remove'
  },
  discard: {
    title: 'Discard changes?',
    text: 'Unsaved changes will be lost',
    cancelText: 'Keep editing',
    confirmText: 'Discard changes'
  },
  removeItem: {
    title: 'Remove item?',
    text: 'This item will be removed from selected items',
    cancelText: 'Cancel',
    confirmText: 'Remove'
  },
  removeAll: {
    title: 'Remove all?',
    text: 'All apps will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Remove'
  },
  removeDashboard: {
    title: 'Delete dashboard?',
    text: 'This dashboard will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Delete'
  },
  removeTab: {
    title: 'Remove tab?',
    text: 'This tab will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Remove'
  },
  removeDashboardItem: {
    title: 'Remove item?',
    text: 'This item will be removed from your dashboard',
    cancelText: 'Cancel',
    confirmText: 'Remove'
  },
  cancelExport: {
    title: 'Cancel current export?',
    text: "Your selection will be cleared and the export won't complete",
    cancelText: 'Stay and continue',
    confirmText: 'Yes, cancel'
  }
} satisfies Record<string, CancelablePopupContent>;

export default presets;
